module.exports = __webpack_public_path__ + "static/media/the-how-photographer.25683300.jpg";